export enum ReviewsAndAnswersStatisticsUnitMeasurementEnum {
    Days = 'Days',
    Hours = 'Hours',
    Minutes = 'Minutes',
}
